import { useAuth0 } from "@auth0/auth0-react"
import { Button } from "@mui/material"
import { useTranslation } from "react-i18next"

const LoginButton = () => {
  const { loginWithRedirect } = useAuth0()
  const { t } = useTranslation()

  const handleLogin = () => {
    const params = new URLSearchParams(window.location.search)
    const wasUnauthorized = params.get("reason") === "unauthorized"
    loginWithRedirect({
      authorizationParams: wasUnauthorized ? { prompt: "login" } : undefined,
    })
  }

  return (
    <Button
      id="login-button"
      data-testid="login-btn"
      variant="contained"
      onClick={handleLogin}
      sx={(theme) => ({
        textTransform: "none",
        width: "100%",
        py: 1.25,
        fontSize: "0.9rem",
        fontWeight: 600,
        borderRadius: 99,
        boxShadow: `0 4px 16px ${theme.palette.primary.main}30`,
        transition: "all 0.25s ease",
        "&:hover": {
          boxShadow: `0 6px 24px ${theme.palette.primary.main}40`,
          transform: "translateY(-1px)",
        },
        "&:active": {
          transform: "translateY(0)",
        },
      })}
    >
      {t("login")}
    </Button>
  )
}

export default LoginButton
